import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faTimes } from '@fortawesome/free-solid-svg-icons';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

const PopUp = () => {
    const [showPopup, setShowPopup] = useState(false);
  const [showIcon, setShowIcon] = useState(true);
const [showMPopup, setShowMPopup] = useState(false);
  const [showMIcon, setShowMIcon] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
      setTimeout(() => {
        setShowPopup(false);
      }, 5000); // Verschwindet nach 5 Sekunden
    }, 2000); // Popup erscheint nach 2 Sekunden
const timerM = setTimeout(() => {
      setShowMPopup(true);
      setTimeout(() => {
        setShowMPopup(false);
      }, 6000); // Verschwindet nach 5 Sekunden
    }, 3000); // Popup erscheint nach 2 Sekunden
    return () => clearTimeout(timer, timerM);
  }, []);

  const handleMouseEnter = () => {
    setShowPopup(true);
  };

  const handleMouseLeave = () => {
    setShowPopup(false);
  };

  const handleClose = () => {
    setShowPopup(false);
    setShowIcon(false);
  };

  const handleMMouseEnter = () => {
    setShowMPopup(true);
  };

  const handleMMouseLeave = () => {
    setShowMPopup(false);
  };

  const handleMClose = () => {
    setShowMPopup(false);
    setShowMIcon(false);
  };

  return (
    <>
     <div className="fixed top-1/3 right-0 transform -translate-y-1/2 flex items-center z-40">
       <div
        className={`bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-600 text-white rounded-l-lg p-4 flex items-center transition-transform duration-300 ${
          showMPopup ? 'translate-x-0' : 'translate-x-full'
        }`}
        onMouseLeave={handleMMouseLeave}
      >
        <a href="https://www.stadtwerkstatt-bautzen.de/kontakt" target="_blank" rel="noopener noreferrer" className="mr-2">
          Mietregal ab 01.01.2026 frei
        </a>
        <FontAwesomeIcon
          icon={faTimes}
          onClick={handleMClose}
          className="w-6 h-6 cursor-pointer"
        />
      </div>
      {showMIcon && (
        <div
          className="bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-600 z-10 via-pink-500 to-blue-600 text-white rounded-l-lg p-4 flex items-center cursor-pointer"
          onMouseEnter={handleMMouseEnter}
        >
          Bewirb Dich jetzt!
        </div>
      )}

     </div>
    <div className="fixed top-1/2 right-0 transform -translate-y-1/2 flex items-center z-50">
    
      <div
        className={`bg-gradient-to-r z-0 from-yellow-400 via-pink-500 to-purple-600 text-white rounded-l-lg p-4 flex items-center transition-transform duration-300 ${
          showPopup ? 'translate-x-0' : 'translate-x-full'
        }`}
        onMouseLeave={handleMouseLeave}
      >
        <a href="https://www.instagram.com/stadt_werk_statt/" target="_blank" rel="noopener noreferrer" className="mr-2">
          Folge uns auf Instagram
        </a>
        <FontAwesomeIcon
          icon={faTimes}
          onClick={handleClose}
          className="w-6 h-6 cursor-pointer"
        />
      </div>
      {showIcon && (
        <div
          className="bg-gradient-to-r from-yellow-400 z-10 via-pink-500 to-purple-600 text-white rounded-l-lg p-4 flex items-center cursor-pointer"
          onMouseEnter={handleMouseEnter}
        >
          <FontAwesomeIcon icon={faInstagram} className="w-6 h-6" />
        </div>
      )}
    </div></>
  );
};

export default PopUp;
